import { render, staticRenderFns } from "./LmPhoneInput.vue?vue&type=template&id=53594b66&scoped=true&"
import script from "./LmPhoneInput.vue?vue&type=script&lang=js&"
export * from "./LmPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./LmPhoneInput.vue?vue&type=style&index=0&id=53594b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53594b66",
  null
  
)

export default component.exports